import React from 'react'
import PropTypes from 'prop-types'
import {Box, useMultiStyleConfig} from '@chakra-ui/react'
import {Swiper, SwiperSlide} from 'swiper/react'
import {Pagination} from 'swiper/modules'
import Benefit from './benefit'
import {remCalc} from '../../theme/_utils'

const BenefitIconsSwiper = ({benefitGroup}) => {
    const swiperStyles = useMultiStyleConfig('Swiper')

    return (
        <Box
            data-testid="swiper-container"
            width="100%"
            height="100%"
            maxW={{
                base: remCalc(260),
                md: remCalc(386),
                lg: remCalc(386),
                xl: remCalc(570),
            }}
            maxH={{
                base: remCalc(260),
                md: remCalc(386),
                lg: remCalc(386),
                xl: remCalc(570),
            }}
            __css={swiperStyles}
        >
            <Swiper
                data-testid="swiper"
                pagination={{
                    clickable: true,
                    el: '.swiper-pagination',
                }}
                modules={[Pagination]}
                className="befit-icons-swiper"
            >
                {benefitGroup.map(({description, title, icon}, index) => (
                    <SwiperSlide key={index}>
                        <Benefit
                            title={title}
                            description={description}
                            url={icon?.url}
                            alt={title}
                        />
                    </SwiperSlide>
                ))}
                <Box className="swiper-pagination" />
            </Swiper>
        </Box>
    )
}

BenefitIconsSwiper.propTypes = {
    benefitGroup: PropTypes.arrayOf(
        PropTypes.shape({
            description: PropTypes.string,
            title: PropTypes.string,
            icon: PropTypes.shape({url: PropTypes.string}),
        }),
    ),
}

export default BenefitIconsSwiper
